<section class="container pia-fullPreviewBlock pia-mainContainerBlock">
  <!-- Preview navigation -->
  <div class="row">
    @if (!onlyData) { @if (pia.is_example === 1) {
    <div class="pia-breadcrumb hide-for-print small-12 medium-12 columns">
      <a [routerLink]="['/entries']"
        >{{ "header.help.title" | translate }} >
        {{ "header.current_pias" | translate }}</a
      ><strong> > {{ "header.help.pia_example_link" | translate }}</strong>
    </div>
    } @if (pia.is_example === 0) {
    <div class="pia-breadcrumb hide-for-print small-12 medium-12 columns">
      @if (pia.is_archive === 1) {
      <span>
        <a [routerLink]="['/entries', 'archive']"
          >{{ "header.homepage_link" | translate }} >
          {{ "header.archives" | translate }}</a
        ><strong> > {{ pia.name }}</strong>
      </span>
      } @else {
      <a [routerLink]="['/entries']"
        >{{ "header.homepage_link" | translate }} >
        {{ "header.current_pias" | translate }}</a
      ><strong> > {{ pia.name }}</strong>
      }
    </div>
    } } @if (!onlyData) {
    <nav class="small-12 medium-3 columns hide-for-print">
      <div class="pia-leftSidebarBlock pia-fullPreviewBlock-section">
        <div class="pia-sectionsBlock">
          <div class="pia-sectionBlock-header">
            <h1 class="truncate" title="{{ pia.name }}">{{ pia.name }}</h1>
            <a
              class="pia-icons pia-icon-close-big"
              [routerLink]="
                fromArchives ? ['/entries', 'archive'] : ['/entries']
              "
              title="{{ 'pia.sections.homepage_link' | translate }}"
            ></a>
          </div>
          @if (pia.structure_id) {
          <div class="pia-sectionBlock-structure">
            {{ "pia.sections.based_on_structure_name" | translate }}
            {{ pia.structure_name }}
          </div>
          } @if (pia.category) {
          <div class="pia-sectionBlock-category">
            {{ "homepage.cards.category" | translate }} "{{ pia.category }}"
          </div>
          }
          <div class="pia-sectionBlock-body">
            @for (dataSection of data?.sections; track dataSection) {
            <div>
              <div class="pia-sectionBlock-title">
                {{ dataSection.title | translate }}
                <hr />
              </div>
              <ul class="pia-sectionBlock-list">
                @for (dataItem of dataSection?.items; track dataItem) { @if
                (!dataItem.hide) {
                <li>
                  <a
                    href="javascript:;"
                    (click)="getAnchor($event, dataItem.title)"
                    class="truncate"
                  >
                    {{ dataItem.title | translate }}</a
                  >
                </li>
                } }
              </ul>
            </div>
            }
          </div>
          <!-- Attachments -->
          <app-attachments [isPreview]="true" [pia]="pia"></app-attachments>
        </div>
      </div>
    </nav>
    }

    <!-- Preview content + preview actions -->
    <section class=" small-12 medium-6 columns pia-fullPreviewBlock-content">
      <div
        class="container pia-fullPreviewContainerBlock pia-mainContainerBlock"
      >
        <div class="pia-fullPreviewBlock-data">
          <header class="pia-fullPreviewBlock-header">
            <div>
              <span class="pia-icons pia-icon-white-preview"></span>
              <div>{{ "pia.header.preview" | translate }}</div>
            </div>
            <div class="pia-fullPreviewBlock-header-title">
              <h1>{{ "summary.preview_title" | translate }}</h1>
              <h2>{{ "summary.preview_subtitle" | translate }}</h2>
              <div class="pia-fullPreviewBlock-header-data">
                <div>
                  <div>
                    <div>{{ "summary.preview_edition" | translate }} :</div>
                    <div>{{ getUsersList("author", "author_name") }}</div>
                  </div>

                  <div>
                    <div>{{ "summary.preview_evaluation" | translate }} :</div>
                    <div>{{ getUsersList("evaluator", "evaluator_name") }}</div>
                  </div>
                  <div>
                    <div>{{ "summary.preview_validation" | translate }} :</div>
                    <div>{{ getUsersList("validator", "validator_name") }}</div>
                  </div>

                  @if (authService.state) {
                  <div>
                    <div>{{ "summary.preview_guests" | translate }} :</div>
                    <div>{{ getUsersList("guest") }}</div>
                  </div>
                  }
                </div>
                <div>
                  <div>
                    <div>{{ "summary.preview_status" | translate }} :</div>
                    <div>
                      {{ piaService.getStatusName(pia.status) | translate }}
                    </div>
                  </div>
                  <div class="pia-fullPreviewBlock-header-progressBar">
                    <div>{{ pia.progress < 100 ? pia.progress : 100 }}%</div>
                    <progress max="100" value="{{ pia.progress }}"></progress>
                  </div>
                </div>
              </div>
            </div>

            @if (!fromArchives || pia.is_example === 1) {
            <a
              routerLink="/pia/{{ pia.id }}/section/1/item/1"
              class="btn pia-previewBlock"
            >
              <fa-icon [icon]="faPencil"></fa-icon>
              <div>{{ "homepage.cards.item.edit_pia" | translate }}</div>
            </a>
            }
          </header>

          <div class="row" id="pia-full-content">
            <div class="small-12 medium-12 columns">
              <div>
                <!-- VALIDATION - Risks cartography -->
                <section class="section-risks-cartography">
                  <div class="pagebreak-before">
                    <div style="padding-top: 10px">
                      <div class="pia-fullPreviewBlock-headline">
                        <div class="pia-fullPreviewBlock-headline-title">
                          <h1>
                            {{
                              "summary.preview_validation_section" | translate
                            }}
                          </h1>
                          <h2>
                            {{ "summary.risks_cartography_title" | translate }}
                          </h2>
                        </div>
                      </div>
                      <div class="pia-previewRisksCartographyBlock ">
                        <div class="pia-risksCartographyContainer">
                          <div [pia]="pia" class="app-risks-cartography"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- VALIDATION - Action plan -->
                <section class="section-action-plan">
                  <div class="pagebreak-before">
                    <div style="padding-top: 10px;">
                      <div class="pia-fullPreviewBlock-headline">
                        <div class="pia-fullPreviewBlock-headline-title">
                          <h1>
                            {{
                              "summary.preview_validation_section" | translate
                            }}
                          </h1>
                          <h2>{{ "summary.action_plan.title" | translate }}</h2>
                        </div>
                      </div>

                      <div class="actionPlan pia-fullPreviewBlock-actionPlan">
                        <div>
                          <!-- VALIDATION - Action plan - Overview graph -->
                          <div class="pia-actionPlanGraphBlockContainer">
                            <div
                              class="pia-entryContentBlock-content pia-actionPlanGraphBlock"
                              id="actionPlanOverviewImg"
                            >
                              <h3 class="pia-fullPreviewBlock-subheadline">
                                {{ "action_plan.title" | translate }}
                              </h3>
                              <div class="row">
                                <div
                                  class="medium-6 columns pia-actionPlanGraphBlock-left"
                                >
                                  <h3>
                                    {{ "action_plan.principles" | translate }}
                                  </h3>
                                  @for (r of actionPlanService.results; track r)
                                  {
                                  <div class="pia-actionPlanGraphBlock-item">
                                    <span class="pia-list">{{
                                      r.short_title | translate
                                    }}</span>
                                    <span
                                      class="pia-box"
                                      [ngClass]="{
                                        'pia-blue': r.status === 2,
                                        'pia-red': r.status === 1
                                      }"
                                    ></span>
                                    <span
                                      class="pia-box"
                                      [ngClass]="{
                                        'pia-green': r.status === 3,
                                        'pia-red': r.status === 1
                                      }"
                                    ></span>
                                  </div>
                                  }
                                </div>
                                <div
                                  class="medium-6 columns pia-actionPlanGraphBlock-right"
                                >
                                  <h3>
                                    {{ "action_plan.measures" | translate }}
                                  </h3>
                                  <div
                                    class="pia-actionPlanGraphBlock-right-measures summaryMode"
                                  >
                                    @if (actionPlanService.measures) {
                                    <div
                                      class="pia-actionPlanGraphBlock-right-measures-scroll summaryMode"
                                    >
                                      @for ( measure of
                                      actionPlanService.measures ; track
                                      measure) {
                                      <div
                                        class="pia-actionPlanGraphBlock-item"
                                      >
                                        <span
                                          class="pia-box"
                                          [ngClass]="{
                                            'pia-blue': measure.status === 2,
                                            'pia-red': measure.status === 1
                                          }"
                                        ></span>
                                        <span
                                          class="pia-box"
                                          [ngClass]="{
                                            'pia-green': measure.status === 3,
                                            'pia-red': measure.status === 1
                                          }"
                                        ></span>
                                        <span class="pia-list">{{
                                          measure.name
                                        }}</span>
                                      </div>
                                      }
                                    </div>
                                    }
                                  </div>
                                  <h3>{{ "action_plan.risks" | translate }}</h3>
                                  <div class="pia-actionPlanGraphBlock-item">
                                    <span
                                      class="pia-box"
                                      [ngClass]="{
                                        'pia-blue':
                                          actionPlanService.risks['3.2'] &&
                                          actionPlanService.risks['3.2'][
                                            'status'
                                          ] === 2,
                                        'pia-red':
                                          actionPlanService.risks['3.2'] &&
                                          actionPlanService.risks['3.2'][
                                            'status'
                                          ] === 1
                                      }"
                                    ></span>
                                    <span
                                      class="pia-box"
                                      [ngClass]="{
                                        'pia-green':
                                          actionPlanService.risks['3.2'] &&
                                          actionPlanService.risks['3.2'][
                                            'status'
                                          ] === 3,
                                        'pia-red':
                                          actionPlanService.risks['3.2'] &&
                                          actionPlanService.risks['3.2'][
                                            'status'
                                          ] === 1
                                      }"
                                    ></span>
                                    <span class="pia-list">{{
                                      "action_plan.risk1" | translate
                                    }}</span>
                                  </div>
                                  <div class="pia-actionPlanGraphBlock-item">
                                    <span
                                      class="pia-box"
                                      [ngClass]="{
                                        'pia-blue':
                                          actionPlanService.risks['3.3'] &&
                                          actionPlanService.risks['3.3'][
                                            'status'
                                          ] === 2,
                                        'pia-red':
                                          actionPlanService.risks['3.3'] &&
                                          actionPlanService.risks['3.3'][
                                            'status'
                                          ] === 1
                                      }"
                                    ></span>
                                    <span
                                      class="pia-box"
                                      [ngClass]="{
                                        'pia-green':
                                          actionPlanService.risks['3.3'] &&
                                          actionPlanService.risks['3.3'][
                                            'status'
                                          ] === 3,
                                        'pia-red':
                                          actionPlanService.risks['3.3'] &&
                                          actionPlanService.risks['3.3'][
                                            'status'
                                          ] === 1
                                      }"
                                    ></span>
                                    <span class="pia-list">{{
                                      "action_plan.risk2" | translate
                                    }}</span>
                                  </div>
                                  <div class="pia-actionPlanGraphBlock-item">
                                    <span
                                      class="pia-box"
                                      [ngClass]="{
                                        'pia-blue':
                                          actionPlanService.risks['3.4'] &&
                                          actionPlanService.risks['3.4'][
                                            'status'
                                          ] === 2,
                                        'pia-red':
                                          actionPlanService.risks['3.4'] &&
                                          actionPlanService.risks['3.4'][
                                            'status'
                                          ] === 1
                                      }"
                                    ></span>
                                    <span
                                      class="pia-box"
                                      [ngClass]="{
                                        'pia-green':
                                          actionPlanService.risks['3.4'] &&
                                          actionPlanService.risks['3.4'][
                                            'status'
                                          ] === 3,
                                        'pia-red':
                                          actionPlanService.risks['3.4'] &&
                                          actionPlanService.risks['3.4'][
                                            'status'
                                          ] === 1
                                      }"
                                    ></span>
                                    <span class="pia-list">{{
                                      "action_plan.risk3" | translate
                                    }}</span>
                                  </div>
                                </div>
                                <div class="pia-legend">
                                  <p>
                                    {{
                                      "action_plan.improvable_measures"
                                        | translate
                                    }}
                                  </p>
                                  <p>
                                    {{
                                      "action_plan.acceptable_measures"
                                        | translate
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- VALIDATION - Action plan - Fundamental principles -->
                          <div class="">
                            @if ( actionPlanService.principlesActionPlanReady) {
                            <div class="actionplanbox">
                              <h3 class="pia-fullPreviewBlock-subheadline">
                                {{
                                  "summary.action_plan.fundamental_principles"
                                    | translate
                                }}
                              </h3>
                              @for ( entry of actionPlanService.results ; track
                              entry) {
                              <div>
                                @if ( entry.action_plan_comment &&
                                entry.action_plan_comment.length > 0 ) {
                                <div
                                  style="border:0.5px dotted #A7A7A7;padding:6px;margin:10px 0;"
                                >
                                  <h3 style="margin-bottom:2px;">
                                    {{ entry.short_title | translate }}
                                  </h3>
                                  <div>
                                    <strong
                                      >{{
                                        "evaluations.action_plan_comment"
                                          | translate
                                      }}
                                      :<br
                                    /></strong>
                                    <span
                                      [innerHTML]="
                                        entry.action_plan_comment
                                          | translate
                                          | safeHtml
                                      "
                                    ></span>
                                  </div>
                                  @if ( entry.evaluation_comment &&
                                  entry.evaluation_comment.length > 0 ) {
                                  <div>
                                    <strong
                                      >{{
                                        "evaluations.evaluation_comment"
                                          | translate
                                      }}
                                      :<br
                                    /></strong>
                                    <span
                                      [innerHTML]="
                                        entry.evaluation_comment | safeHtml
                                      "
                                    ></span>
                                  </div>
                                  } @if ( entry.evaluation && entry.evaluation
                                  .estimated_implementation_date &&
                                  entry.evaluation.estimated_implementation_date.toString()
                                  !== 'Invalid Date' ) {
                                  <div>
                                    <strong
                                      >{{
                                        "summary.action_plan.implementation_date"
                                          | translate
                                      }}
                                      :
                                    </strong>
                                    <time>{{
                                      entry.evaluation
                                        .estimated_implementation_date
                                        | date
                                          : "shortDate"
                                          : ""
                                          : languagesService.selectedLanguage
                                    }}</time>
                                  </div>
                                  } @if ( entry.evaluation &&
                                  entry.evaluation.person_in_charge ) {
                                  <div>
                                    <strong
                                      >{{
                                        "summary.action_plan.implementation_responsible"
                                          | translate
                                      }}
                                      :
                                    </strong>
                                    {{ entry.evaluation.person_in_charge }}
                                  </div>
                                  }
                                </div>
                                }
                              </div>
                              }
                            </div>
                            } @else {
                            <div class="actionplanbox">
                              <h3 class="pia-fullPreviewBlock-subheadline">
                                {{
                                  "summary.action_plan.fundamental_principles"
                                    | translate
                                }}
                              </h3>
                              {{
                                "summary.action_plan.no_action_plan" | translate
                              }}
                            </div>
                            }
                          </div>

                          <!-- VALIDATION - Action plan - Measures -->
                          <div class="">
                            @if ( actionPlanService.measuresActionPlanReady) {
                            <div class="actionplanbox">
                              <h3 class="pia-fullPreviewBlock-subheadline">
                                {{ "summary.action_plan.measures" | translate }}
                              </h3>
                              @for ( entry of actionPlanService.measures ; track
                              entry) {
                              <div>
                                @if ( entry.action_plan_comment &&
                                entry.action_plan_comment.length > 0 ) {
                                <div
                                  style="border:0.5px dotted #A7A7A7;padding:6px;margin:10px 0;"
                                >
                                  <h3 style="margin-bottom:2px;">
                                    {{ entry.short_title | translate }}
                                  </h3>
                                  <div>
                                    <strong
                                      >{{
                                        "evaluations.action_plan_comment"
                                          | translate
                                      }}
                                      :<br
                                    /></strong>
                                    <span
                                      [innerHTML]="
                                        entry.action_plan_comment
                                          | translate
                                          | safeHtml
                                      "
                                    ></span>
                                  </div>
                                  @if ( entry.evaluation_comment &&
                                  entry.evaluation_comment.length > 0 ) {
                                  <div>
                                    <strong
                                      >{{
                                        "evaluations.evaluation_comment"
                                          | translate
                                      }}
                                      :<br
                                    /></strong>
                                    <span
                                      [innerHTML]="
                                        entry.evaluation_comment | safeHtml
                                      "
                                    ></span>
                                  </div>
                                  } @if ( entry.evaluation && entry.evaluation
                                  .estimated_implementation_date &&
                                  entry.evaluation.estimated_implementation_date.toString()
                                  !== 'Invalid Date' ) {
                                  <div>
                                    <strong
                                      >{{
                                        "summary.action_plan.implementation_date"
                                          | translate
                                      }}
                                      :
                                    </strong>
                                    <time>{{
                                      entry.evaluation
                                        .estimated_implementation_date
                                        | date
                                          : "shortDate"
                                          : ""
                                          : languagesService.selectedLanguage
                                    }}</time>
                                  </div>
                                  } @if ( entry.evaluation &&
                                  entry.evaluation.person_in_charge ) {
                                  <div>
                                    <strong
                                      >{{
                                        "summary.action_plan.implementation_responsible"
                                          | translate
                                      }}
                                      :
                                    </strong>
                                    {{ entry.evaluation.person_in_charge }}
                                  </div>
                                  }
                                </div>
                                }
                              </div>
                              }
                            </div>
                            } @else {
                            <div class="actionplanbox">
                              <h3 class="pia-fullPreviewBlock-subheadline">
                                {{ "summary.action_plan.measures" | translate }}
                              </h3>
                              {{
                                "summary.action_plan.no_action_plan" | translate
                              }}
                            </div>
                            }
                          </div>

                          <!-- VALIDATION - Action plan - Risks -->
                          <div class="">
                            <!-- Risk 1 -->
                            @if (actionPlanService.risksActionPlan32Ready) {
                            <div>
                              <div class="actionplanbox">
                                <h3 class="pia-fullPreviewBlock-subheadline">
                                  {{ "summary.action_plan.risks" | translate }}
                                  -
                                  {{
                                    actionPlanService.risks["3.2"].short_title
                                      | translate
                                  }}
                                </h3>
                                <strong
                                  >{{
                                    "evaluations.action_plan_comment"
                                      | translate
                                  }}
                                  :
                                </strong>
                                <div
                                  [innerHTML]="
                                    actionPlanService.risks['3.2']
                                      .action_plan_comment
                                      | translate
                                      | safeHtml
                                  "
                                ></div>
                                @if ( actionPlanService.risks['3.2']
                                .evaluation_comment &&
                                actionPlanService.risks['3.2']
                                .evaluation_comment.length > 0 ) {
                                <div>
                                  <strong
                                    >{{
                                      "evaluations.evaluation_comment"
                                        | translate
                                    }}
                                    :<br
                                  /></strong>
                                  <span
                                    [innerHTML]="
                                      actionPlanService.risks['3.2']
                                        .evaluation_comment | safeHtml
                                    "
                                  ></span>
                                </div>
                                }
                                <!-- Estimated implementation date & implementation responsible -->
                                @if ( actionPlanService.risks['3.2'].evaluation
                                && actionPlanService.risks['3.2'].evaluation
                                .estimated_implementation_date &&
                                actionPlanService.risks[ '3.2'
                                ].evaluation.estimated_implementation_date.toString()
                                !== 'Invalid Date' ) {
                                <div class="estimated-implementation-date">
                                  <strong
                                    >{{
                                      "summary.action_plan.implementation_date"
                                        | translate
                                    }}
                                    :
                                  </strong>
                                  <time>{{
                                    actionPlanService.risks["3.2"].evaluation
                                      .estimated_implementation_date
                                      | date
                                        : "shortDate"
                                        : ""
                                        : languagesService.selectedLanguage
                                  }}</time>
                                </div>
                                } @if (
                                actionPlanService.risks['3.2'].evaluation &&
                                actionPlanService.risks['3.2'].evaluation
                                .person_in_charge &&
                                actionPlanService.risks['3.2'].evaluation
                                .person_in_charge.length > 0 ) {
                                <div class="implementation-responsible">
                                  <strong
                                    >{{
                                      "summary.action_plan.implementation_responsible"
                                        | translate
                                    }}
                                    :
                                  </strong>
                                  {{
                                    actionPlanService.risks["3.2"].evaluation
                                      .person_in_charge
                                  }}
                                </div>
                                }
                                <!-- Reviewer gauges -->
                                @if ( actionPlanService.risks['3.2'].evaluation
                                .gauges &&
                                actionPlanService.risks['3.2'].evaluation
                                .gauges.x > 0 ) {
                                <span>
                                  <span
                                    [innerHTML]="
                                      'evaluations.gauges.seriousness'
                                        | translate
                                    "
                                  ></span>
                                  <strong>
                                    {{
                                      "evaluations.gauges." +
                                        actionPlanService.risks["3.2"]
                                          .evaluation.gauges.x | translate
                                    }}</strong
                                  >
                                  <br />
                                </span>
                                } @if (
                                actionPlanService.risks['3.2'].evaluation
                                .gauges &&
                                actionPlanService.risks['3.2'].evaluation
                                .gauges.y > 0 ) {
                                <span>
                                  <span
                                    [innerHTML]="
                                      'evaluations.gauges.likelihood'
                                        | translate
                                    "
                                  ></span>
                                  <strong>
                                    {{
                                      "evaluations.gauges." +
                                        actionPlanService.risks["3.2"]
                                          .evaluation.gauges.y | translate
                                    }}</strong
                                  >
                                </span>
                                }
                              </div>
                            </div>
                            }

                            <!-- Risk 2 -->
                            @if (actionPlanService.risksActionPlan33Ready) {
                            <div>
                              <div class="actionplanbox">
                                <h3 class="pia-fullPreviewBlock-subheadline">
                                  {{ "summary.action_plan.risks" | translate }}
                                  -
                                  {{
                                    actionPlanService.risks["3.3"].short_title
                                      | translate
                                  }}
                                </h3>
                                <strong
                                  >{{
                                    "evaluations.action_plan_comment"
                                      | translate
                                  }}
                                  :
                                </strong>
                                <div
                                  [innerHTML]="
                                    actionPlanService.risks['3.3']
                                      .action_plan_comment
                                      | translate
                                      | safeHtml
                                  "
                                ></div>
                                @if ( actionPlanService.risks['3.3']
                                .evaluation_comment &&
                                actionPlanService.risks['3.3']
                                .evaluation_comment.length > 0 ) {
                                <div>
                                  <strong
                                    >{{
                                      "evaluations.evaluation_comment"
                                        | translate
                                    }}
                                    :<br
                                  /></strong>
                                  <span
                                    [innerHTML]="
                                      actionPlanService.risks['3.3']
                                        .evaluation_comment | safeHtml
                                    "
                                  ></span>
                                </div>
                                }
                                <!-- Estimated implementation date & implementation responsible -->
                                @if ( actionPlanService.risks['3.3'].evaluation
                                && actionPlanService.risks['3.3'].evaluation
                                .estimated_implementation_date &&
                                actionPlanService.risks[ '3.3'
                                ].evaluation.estimated_implementation_date.toString()
                                !== 'Invalid Date' ) {
                                <div class="estimated-implementation-date">
                                  <strong
                                    >{{
                                      "summary.action_plan.implementation_date"
                                        | translate
                                    }}
                                    :
                                  </strong>
                                  <time>{{
                                    actionPlanService.risks["3.3"].evaluation
                                      .estimated_implementation_date
                                      | date
                                        : "shortDate"
                                        : ""
                                        : languagesService.selectedLanguage
                                  }}</time>
                                </div>
                                } @if (
                                actionPlanService.risks['3.3'].evaluation &&
                                actionPlanService.risks['3.3'].evaluation
                                .person_in_charge &&
                                actionPlanService.risks['3.3'].evaluation
                                .person_in_charge.length > 0 ) {
                                <div class="implementation-responsible">
                                  <strong
                                    >{{
                                      "summary.action_plan.implementation_responsible"
                                        | translate
                                    }}
                                    :
                                  </strong>
                                  {{
                                    actionPlanService.risks["3.3"].evaluation
                                      .person_in_charge
                                  }}
                                </div>
                                }
                                <!-- Reviewer gauges -->
                                @if ( actionPlanService.risks['3.3'].evaluation
                                .gauges &&
                                actionPlanService.risks['3.3'].evaluation
                                .gauges.x > 0 ) {
                                <span>
                                  <span
                                    [innerHTML]="
                                      'evaluations.gauges.seriousness'
                                        | translate
                                    "
                                  ></span>
                                  <strong>
                                    {{
                                      "evaluations.gauges." +
                                        actionPlanService.risks["3.3"]
                                          .evaluation.gauges.x | translate
                                    }}</strong
                                  >
                                  <br />
                                </span>
                                } @if (
                                actionPlanService.risks['3.3'].evaluation
                                .gauges &&
                                actionPlanService.risks['3.3'].evaluation
                                .gauges.y > 0 ) {
                                <span>
                                  <span
                                    [innerHTML]="
                                      'evaluations.gauges.likelihood'
                                        | translate
                                    "
                                  ></span>
                                  <strong>
                                    {{
                                      "evaluations.gauges." +
                                        actionPlanService.risks["3.3"]
                                          .evaluation.gauges.y | translate
                                    }}</strong
                                  >
                                </span>
                                }
                              </div>
                            </div>
                            }

                            <!-- Risk 3 -->
                            @if (actionPlanService.risksActionPlan34Ready) {
                            <div>
                              <div class="actionplanbox">
                                <h3 class="pia-fullPreviewBlock-subheadline">
                                  {{ "summary.action_plan.risks" | translate }}
                                  -
                                  {{
                                    actionPlanService.risks["3.4"].short_title
                                      | translate
                                  }}
                                </h3>
                                <strong
                                  >{{
                                    "evaluations.action_plan_comment"
                                      | translate
                                  }}
                                  :
                                </strong>
                                <div
                                  [innerHTML]="
                                    actionPlanService.risks['3.4']
                                      .action_plan_comment
                                      | translate
                                      | safeHtml
                                  "
                                ></div>
                                @if ( actionPlanService.risks['3.4']
                                .evaluation_comment &&
                                actionPlanService.risks['3.4']
                                .evaluation_comment.length > 0 ) {
                                <div>
                                  <strong
                                    >{{
                                      "evaluations.evaluation_comment"
                                        | translate
                                    }}
                                    :<br
                                  /></strong>
                                  <span
                                    [innerHTML]="
                                      actionPlanService.risks['3.4']
                                        .evaluation_comment | safeHtml
                                    "
                                  ></span>
                                </div>
                                }
                                <!-- Estimated implementation date & implementation responsible -->
                                @if ( actionPlanService.risks['3.4'].evaluation
                                && actionPlanService.risks['3.4'].evaluation
                                .estimated_implementation_date &&
                                actionPlanService.risks[ '3.4'
                                ].evaluation.estimated_implementation_date.toString()
                                !== 'Invalid Date' ) {
                                <div class="estimated-implementation-date">
                                  <strong
                                    >{{
                                      "summary.action_plan.implementation_date"
                                        | translate
                                    }}
                                    :
                                  </strong>
                                  <time>{{
                                    actionPlanService.risks["3.4"].evaluation
                                      .estimated_implementation_date
                                      | date
                                        : "shortDate"
                                        : ""
                                        : languagesService.selectedLanguage
                                  }}</time>
                                </div>
                                } @if (
                                actionPlanService.risks['3.4'].evaluation &&
                                actionPlanService.risks['3.4'].evaluation
                                .person_in_charge &&
                                actionPlanService.risks['3.4'].evaluation
                                .person_in_charge.length > 0 ) {
                                <div class="implementation-responsible">
                                  <strong
                                    >{{
                                      "summary.action_plan.implementation_responsible"
                                        | translate
                                    }}
                                    :
                                  </strong>
                                  {{
                                    actionPlanService.risks["3.4"].evaluation
                                      .person_in_charge
                                  }}
                                </div>
                                }
                                <!-- Reviewer gauges -->
                                @if ( actionPlanService.risks['3.4'].evaluation
                                .gauges &&
                                actionPlanService.risks['3.4'].evaluation
                                .gauges.x > 0 ) {
                                <span>
                                  <span
                                    [innerHTML]="
                                      'evaluations.gauges.seriousness'
                                        | translate
                                    "
                                  ></span>
                                  <strong>
                                    {{
                                      "evaluations.gauges." +
                                        actionPlanService.risks["3.4"]
                                          .evaluation.gauges.x | translate
                                    }}</strong
                                  >
                                  <br />
                                </span>
                                } @if (
                                actionPlanService.risks['3.4'].evaluation
                                .gauges &&
                                actionPlanService.risks['3.4'].evaluation
                                .gauges.y > 0 ) {
                                <span>
                                  <span
                                    [innerHTML]="
                                      'evaluations.gauges.likelihood'
                                        | translate
                                    "
                                  ></span>
                                  <strong>
                                    {{
                                      "evaluations.gauges." +
                                        actionPlanService.risks["3.4"]
                                          .evaluation.gauges.y | translate
                                    }}</strong
                                  >
                                </span>
                                }
                              </div>
                            </div>
                            }

                            <!-- No actions plan for risks -->
                            @if ( !actionPlanService.risksActionPlan32Ready &&
                            !actionPlanService.risksActionPlan33Ready &&
                            !actionPlanService.risksActionPlan34Ready ) {
                            <div>
                              <div class="actionplanbox">
                                <h3 class="pia-fullPreviewBlock-subheadline">
                                  {{ "summary.action_plan.risks" | translate }}
                                </h3>
                                {{
                                  "summary.action_plan.no_action_plan"
                                    | translate
                                }}
                              </div>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- VALIDATION - DPO opinions -->
                <section class="section-dpo">
                  <div class="pagebreak-before">
                    <div style="padding-top: 10px;">
                      <div class="pia-fullPreviewBlock-headline">
                        <div class="pia-fullPreviewBlock-headline-title">
                          <h1>
                            {{
                              "summary.preview_validation_section" | translate
                            }}
                          </h1>
                          <h2>
                            {{ "summary.preview_dpo_opinion" | translate }}
                          </h2>
                        </div>
                      </div>

                      <div class="">
                        @for (c of content; track c) {
                        <div>
                          @if (c.data.length > 0) {
                          <div>
                            @for (d of c.data; track d) {
                            <div class="databox">
                              <h3 id="select">{{ d.title | translate }}</h3>
                              @if (d.type !== 'date') {
                              <div
                                style="font-weight:500;"
                                [ngClass]="{
                                  'pia-attachment-removed':
                                    d.comment && d.comment.length > 0
                                }"
                                [innerHTML]="d.content | translate | safeHtml"
                              ></div>
                              } @else { @if ( d.content.toString() !== 'Invalid
                              Date' ) {
                              <time style="font-weight:500;">{{
                                d.content
                                  | date
                                    : "shortDate"
                                    : ""
                                    : languagesService.selectedLanguage
                              }}</time>
                              } } @if ( d.type !== 'date' && d.comment &&
                              d.comment.length > 0 ) {
                              <div
                                [innerHTML]="d.comment | nl2br | safeHtml"
                              ></div>
                              }
                            </div>
                            }
                          </div>
                          } @else {
                          <div class="databox">
                            <div>
                              {{ "summary.preview_no_data" | translate }}
                            </div>
                          </div>
                          }
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              <!-- CONTEXT + FUNDAMENTAL PRINCIPLES + RISKS -->
              @if (allData) {
              <div
                ng-class="{'text-success': model.copied, 'text-danger': !model.copied}"
                ng-copy="events.onCopy($event)"
              >
                @for (section of data.sections; track section) {
                <div>
                  @if (section.id !== 4 && allData[section.id]) {
                  <div class="section-preview section-{{ section.id }}">
                    @for (item of section.items; track item) {
                    <div class="pagebreak-before">
                      @if ( item.evaluation_mode !== '' &&
                      allData[section.id][item.id] ) {
                      <div style="padding-top: 10px;">
                        <div
                          [className]="
                            'pia-fullPreviewBlock-headline headline' +
                            section.id
                          "
                        >
                          <div class="pia-fullPreviewBlock-headline-title">
                            <h1>{{ section.title | translate }}</h1>
                            <h2>{{ item.title | translate }}</h2>
                          </div>
                        </div>
                        <div class="databox">
                          <!-- Measures -->
                          @if (item.is_measure) {
                          <div>
                            @if ( allData[section.id][item.id].length > 0) {
                            @for ( measure of allData[section.id][item.id] ;
                            track measure) {
                            <div>
                              <h3 [innerHTML]="measure.title"></h3>
                              <div
                                [innerHTML]="
                                  measure.content | translate | safeHtml
                                "
                              ></div>
                              <br />
                              <!-- Measures' evaluations -->
                              @if (measure.evaluation) {
                              <div class="evaluationbox">
                                <p>
                                  <strong class="evaluationValue"
                                    >{{ "evaluations.title" | translate }} :
                                    {{
                                      measure.evaluation.title | translate
                                    }}</strong
                                  >
                                  <br />
                                  @if ( measure.evaluation.action_plan_comment )
                                  {
                                  <span>
                                    <strong
                                      >{{
                                        "evaluations.action_plan_comment"
                                          | translate
                                      }}
                                      :<br /></strong
                                    ><span
                                      style="font-weight:400;"
                                      [innerHTML]="
                                        measure.evaluation.action_plan_comment
                                          | safeHtml
                                      "
                                    ></span>
                                    <br />
                                  </span>
                                  } @if ( measure.evaluation.evaluation_comment
                                  ) {
                                  <span>
                                    <strong
                                      >{{
                                        "evaluations.evaluation_comment"
                                          | translate
                                      }}
                                      :<br /></strong
                                    ><span
                                      style="font-weight:400;"
                                      [innerHTML]="
                                        measure.evaluation.evaluation_comment
                                          | safeHtml
                                      "
                                    ></span>
                                    <br />
                                  </span>
                                  }
                                </p>
                              </div>
                              }
                            </div>
                            } } @else {
                            {{ "summary.preview_no_data" | translate }}
                            }
                          </div>
                          }
                          <!-- Questions -->
                          @if (item.questions) {
                          <div>
                            @for (question of item.questions; track question) {
                            <div>
                              <h3 [innerHTML]="question.title | translate"></h3>
                              @if ( allData[section.id][item.id][question.id] )
                              { @if ( allData[section.id][item.id][question.id]
                              .content &&
                              allData[section.id][item.id][question.id]
                              .content.length > 0 ) {
                              <div
                                [innerHTML]="
                                  allData[section.id][item.id][question.id]
                                    .content
                                    | translate
                                    | safeHtml
                                "
                              ></div>
                              } @if ( allData[section.id][item.id][question.id]
                              .evaluation ) {
                              <div class="evaluationbox">
                                <br />
                                <p>
                                  <strong class="evaluationValue"
                                    >{{ "evaluations.title" | translate }} :
                                    {{
                                      allData[section.id][item.id][question.id]
                                        .evaluation.title | translate
                                    }}</strong
                                  >
                                  <br />
                                  @if ( allData[section.id][item.id][
                                  question.id ].evaluation.action_plan_comment )
                                  {
                                  <span>
                                    <strong
                                      >{{
                                        "evaluations.action_plan_comment"
                                          | translate
                                      }}
                                      :<br /></strong
                                    ><span
                                      [innerHTML]="
                                        allData[section.id][item.id][
                                          question.id
                                        ].evaluation.action_plan_comment
                                          | safeHtml
                                      "
                                    ></span>
                                    <br />
                                  </span>
                                  } @if ( allData[section.id][item.id][
                                  question.id ].evaluation.evaluation_comment )
                                  {
                                  <span>
                                    <strong
                                      >{{
                                        "evaluations.evaluation_comment"
                                          | translate
                                      }}
                                      :<br /></strong
                                    ><span
                                      [innerHTML]="
                                        allData[section.id][item.id][
                                          question.id
                                        ].evaluation.evaluation_comment
                                          | safeHtml
                                      "
                                    ></span>
                                    <br />
                                  </span>
                                  }
                                  <!-- Gauges' values -->
                                  @if ( allData[section.id][item.id][
                                  question.id ].evaluation.gauges &&
                                  allData[section.id][item.id][ question.id
                                  ].evaluation.gauges.seriousness > 0 ) {
                                  <span>
                                    <span
                                      [innerHTML]="
                                        'evaluations.gauges.seriousness'
                                          | translate
                                      "
                                    ></span>
                                    {{
                                      "evaluations.gauges." +
                                        allData[section.id][item.id][
                                          question.id
                                        ].evaluation.gauges.seriousness
                                        | translate
                                    }}
                                    <br />
                                  </span>
                                  } @if ( allData[section.id][item.id][
                                  question.id ].evaluation.gauges &&
                                  allData[section.id][item.id][ question.id
                                  ].evaluation.gauges.likelihood > 0 ) {
                                  <span>
                                    <span
                                      [innerHTML]="
                                        'evaluations.gauges.likelihood'
                                          | translate
                                      "
                                    ></span>
                                    {{
                                      "evaluations.gauges." +
                                        allData[section.id][item.id][
                                          question.id
                                        ].evaluation.gauges.likelihood
                                        | translate
                                    }}
                                  </span>
                                  }
                                </p>
                              </div>
                              } }
                            </div>
                            }
                          </div>
                          }
                          <!-- Evaluations -->
                          @if ( allData[section.id][item.id]['evaluation_item']
                          ) {
                          <div class="evaluationbox">
                            <br />
                            <p>
                              <strong class="evaluationValue"
                                >{{ "evaluations.title" | translate }} :
                                {{
                                  allData[section.id][item.id][
                                    "evaluation_item"
                                  ].title | translate
                                }}</strong
                              >
                              <br />
                              @if ( allData[section.id][item.id][
                              'evaluation_item' ].action_plan_comment ) {
                              <span>
                                <strong
                                  >{{
                                    "evaluations.action_plan_comment"
                                      | translate
                                  }}
                                  :<br /></strong
                                ><span
                                  [innerHTML]="
                                    allData[section.id][item.id][
                                      'evaluation_item'
                                    ].action_plan_comment | safeHtml
                                  "
                                ></span>
                                <br />
                              </span>
                              } @if ( allData[section.id][item.id][
                              'evaluation_item' ].evaluation_comment ) {
                              <span>
                                <strong
                                  >{{
                                    "evaluations.evaluation_comment" | translate
                                  }}
                                  :<br /></strong
                                ><span
                                  [innerHTML]="
                                    allData[section.id][item.id][
                                      'evaluation_item'
                                    ].evaluation_comment | safeHtml
                                  "
                                ></span>
                                <br />
                              </span>
                              } @if ( allData[section.id][item.id][
                              'evaluation_item' ].gauges &&
                              allData[section.id][item.id][ 'evaluation_item'
                              ].gauges.seriousness > 0 ) {
                              <span>
                                <span
                                  [innerHTML]="
                                    'evaluations.gauges.seriousness' | translate
                                  "
                                ></span>
                                {{
                                  "evaluations.gauges." +
                                    allData[section.id][item.id][
                                      "evaluation_item"
                                    ].gauges.seriousness | translate
                                }}
                                <br />
                              </span>
                              } @if ( allData[section.id][item.id][
                              'evaluation_item' ].gauges &&
                              allData[section.id][item.id][ 'evaluation_item'
                              ].gauges.likelihood > 0 ) {
                              <span>
                                <span
                                  [innerHTML]="
                                    'evaluations.gauges.likelihood' | translate
                                  "
                                ></span>
                                {{
                                  "evaluations.gauges." +
                                    allData[section.id][item.id][
                                      "evaluation_item"
                                    ].gauges.likelihood | translate
                                }}
                              </span>
                              }
                            </p>
                          </div>
                          }
                        </div>
                      </div>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
                }
              </div>
              }

              <!-- RISKS - Risks overview -->
              <section class="section-overview">
                <div class="pagebreak-before">
                  <div style="padding-top: 10px;">
                    <div class="pia-fullPreviewBlock-headline headline3">
                      <div class="pia-fullPreviewBlock-headline-title">
                        <h1>{{ "summary.action_plan.risks" | translate }}</h1>
                        <h2>
                          {{ "summary.risks_overview_title" | translate }}
                        </h2>
                      </div>
                    </div>

                    <div class="pia-previewRisksOverviewBlock">
                      <div class="risksOverview">
                        <div [pia]="pia" class="app-overview-risks"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>

    @if (!onlyData) {
    <aside class="small-12 medium-3 columns pia-fullPreviewBlock-aside">
      <div class="pia-fullPreviewBlock-aside-content">
        @if (pia.is_example == 0 && pia.is_archive == 0) {
        <app-revisions
          [pia]="pia"
          [title]="false"
          [currentVersion]="pia.updated_at"
        >
        </app-revisions>
        }
        <app-export [pia]="pia" (downloading)="download = $event"></app-export>
      </div>
    </aside>
    }
  </div>
</section>

<app-loading-overlay [visibility]="download"></app-loading-overlay>
